import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

import store from './store/'
import standaloneClaimForm from '@/mixins/standaloneClaimForm'

const { default: formRoutes } = require(`./routes/${process.env.VUE_APP_FORM_TYPE}Form.js`)

Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/error',
      name: 'error',
      components: { main: () => import(/* webpackChunkName: "errorView" */ './components/ErrorView.vue')}
    },
    {
      path: '/home',
      name: 'home',
      components: { main: Home }
    },
    {
      path: '/handover/:id',
      name: 'handover',
      beforeEnter (to, from, next) {
        let formId = to.params.id

        store.dispatch('claimform/getHandoverDetails', formId)

        next('/makeaclaim/3')
      }
    },
    /* --------------------------------------------------------------------------------------------------------- */
    ...formRoutes,
    /* --------------------------------------------------------------------------------------------------------- */
    {
      path: '/myclaims',
      name: 'myclaims',
      components: { main: () => import(/* webpackChunkName: "myclaims" */ './views/MyClaims.vue') },
      meta: {
        requireAuth: true
      },
      redirect: '/myclaims/list',
      children: [
        {
          path: '/myclaims/inprogress',
          name: 'inprogress',
          components: { myclaims: () => import(/* webpackChunkName: "myclaims" */ './views/ClaimFormList.vue') }
        },
        {
          path: '/myclaims/list',
          name: 'claimslist',
          beforeEnter (to, from, next) {    
            store.dispatch('myclaims/resetGadget')
            store.dispatch('myclaims/resetClaim')
            store.dispatch('repairoptions/reset')
            next(next)
          },
          components: { myclaims: () => import(/* webpackChunkName: "myclaims" */ './views/ClaimsList.vue') }
        },
        {
          path: '/myclaims/view/:id',
          name: 'viewclaim',
          beforeEnter (to, from, next) { 
            store.dispatch('myclaims/resetGadget')   
            store.dispatch('repairoptions/reset')
            next(next)
          },
          components: { myclaims: () => import(/* webpackChunkName: "myclaims" */ './views/ViewClaim.vue') }
        },
        {
          path: '/myclaims/repairoptions',
          name: 'repairoptions',
          components: { myclaims: () => import(/* webpackChunkName: "myclaims" */ './views/RepairOptions.vue') }
        },
        {
          path: '/myclaims/repairoptions/list/:id?',
          name: 'repairoptionslist',
          beforeEnter (to, from, next) { 
            store.dispatch('repairoptions/reset')
            next(next)
          },
          components: { myclaims: () => import(/* webpackChunkName: "myclaims" */ './views/repairoptions/RepairOptionsList.vue') }
        },
        {
          path: '/myclaims/repairoptions/info/:id?',
          name: 'repairoptionsinfo',
          components: { myclaims: () => import(/* webpackChunkName: "myclaims" */ './views/repairoptions/RepairOptionsInfo.vue') }
        },
        {
          path: '/myclaims/repairoptions/continue/:id?',
          name: 'repairoptionsinfo',
          components: { myclaims: () => import(/* webpackChunkName: "myclaims" */ './views/repairoptions/RepairOptionsContinue.vue') }
        },
        {
          path: '/myclaims/repairoptions/instructions/:id?',
          name: 'repairoptionsinstructions',
          components: { myclaims: () => import(/* webpackChunkName: "myclaims" */ './views/repairoptions/RepairOptionsInstructions.vue') }
        },
        {
          path: '/myclaims/repairoptions/cancel/:id?',
          name: 'repairoptionscancel',
          components: { myclaims: () => import(/* webpackChunkName: "myclaims" */ './views/repairoptions/RepairOptionsCancel.vue') }
        },
        {
          path: '/myclaims/repairoptions/booking/:id?',
          name: 'repairoptionsbooking',
          components: { myclaims: () => import(/* webpackChunkName: "myclaims" */ './views/repairoptions/RepairOptionsBooking.vue') }
        },
        {
          path: '/myclaims/repairoptions/bookingmod',
          name: 'repairoptionsbookingmod',
          components: { myclaims: () => import(/* webpackChunkName: "myclaims" */ './views/repairoptions/RepairOptionsBookingMod.vue') }
        },
        {
          path: '/myclaims/repairoptions/bookingdte',
          name: 'repairoptionsbookingdte',
          components: { myclaims: () => import(/* webpackChunkName: "myclaims" */ './views/repairoptions/RepairOptionsBookingDte.vue') }
        },
        {
          path: '/myclaims/repairoptions/bookinginfo',
          name: 'repairoptionsbookinginfo',
          components: { myclaims: () => import(/* webpackChunkName: "myclaims" */ './views/repairoptions/RepairOptionsBookingInfo.vue') }
        },
        {
          path: '/myclaims/repairoptions/bankdetails/:id?',
          redirect: to => {
            return { path: '/myclaims/repairoptions/uploaddocscp', query: { id: to.params.id} }
          }
        },
        {
          path: '/myclaims/repairoptions/editbankdetails/:id?/:standAlone?',
          name: 'repairoptionseditbankdetails',
          components: { myclaims: () => import(/* webpackChunkName: "myclaims" */ './views/repairoptions/RepairOptionsBankDetails.vue') }
        },
        {
          path: '/myclaims/repairoptions/uploaddocs/:id?',
          name: 'repairoptionsuploaddocs',
          components: { myclaims: () => import(/* webpackChunkName: "myclaims" */ './views/repairoptions/RepairOptionsUploadDocs.vue') }
        },
        {
          path: '/myclaims/repairoptions/uploaddocscp/:id?',
          name: 'repairoptionsuploaddocscp',
          components: { myclaims: () => import(/* webpackChunkName: "myclaims" */ './views/repairoptions/RepairOptionsUploadDocsV2.vue') }
        },
        {
          path: '/myclaims/uploadinvoice',
          name: 'uploaddocs',
          components: { myclaims: () => import(/* webpackChunkName: "myclaims" */ './views/UploadRepairDocs.vue') }
        },
        {
          path: '/myclaims/supportingdocs/:id?',
          name: 'uploaddocs',
          components: { myclaims: () => import(/* webpackChunkName: "myclaims" */ './views/documents/SupportingDocUpload.vue') }
        }
      ]
    },
    {
      path: '/login/:new_password?',
      name: 'login',
      components: { main: () => import(/* webpackChunkName: "auth" */ './views/Login.vue') }
    },
    {
      path: '/resetpassword',
      name: 'resetpassword',
      components: { main: () => import(/* webpackChunkName: "auth" */ './views/ResetPassword.vue') }
    },
    {
      path: '/changepassword',
      name: 'changepassword',
      components: { main: () => import(/* webpackChunkName: "auth" */ './views/ChangePassword.vue') }
    },
    {
      path: '/logout',
      name: 'logout',
      components: { main: () => import(/* webpackChunkName: "auth" */ './views/Logout.vue') }
    },
    {
      path: '/help',
      name: 'help',
      components: { main: () => import(/* webpackChunkName: "help" */ './views/Help.vue') }
    },
    {
      path: '/terms',
      name: 'terms',
      components: { main: () => import(/* webpackChunkName: "terms" */ './views/Terms.vue') }
    },
    {
      path: '/contact',
      name: 'contact',
      components: { main: () => import(/* webpackChunkName: "terms" */ './views/Contact.vue') }
    }
  ]
})
